export const howItWorks = {
  hero: {
    badge: "Guide complet",
    title: "Comment fonctionne DONKEY TRAVEL ?",
    subtitle:
      "Découvrez étape par étape comment échanger votre logement Airbnb avec d'autres propriétaires et voyager gratuitement partout en Europe.",
    cta: "Commencer maintenant",
    learnMore: "Voir les étapes",
  },
  stats: {
    properties: "Logements disponibles",
    exchanges: "Échanges réalisés",
    countries: "Pays couverts",
    satisfaction: "Satisfaction",
  },
  steps: {
    badge: "Le processus",
    title: "Votre échange en 7 étapes",
    subtitle:
      "Un parcours simple et sécurisé, de l'inscription à votre premier voyage gratuit",
    step1: {
      title: "Créez votre profil (15 min)",
      description:
        "C'est l'étape la plus \"longue\" : 15 minutes pour créer votre profil. Un petit effort pour des années de vacances gratuites et de bonheur !",
      highlight1: "Abonnement requis",
      highlight2: "Annonce complète avec photos",
      highlight3: "Vérification d'identité",
      badge: "Inscription rapide",
    },
    step2: {
      title: "Explorez et trouvez votre destination idéale",
      description:
        "Parcourez notre carte interactive d'Europe et trouvez des hôtes vérifiés du club. Filtrez par destination, dates, type de logement et équipements pour organiser votre échange.",
      highlight1: "Carte interactive Europe avec filtres avancés",
      highlight2: "Recherche par destination, dates et équipements",
      highlight3: "Membres hôtes vérifiés dans les pays européens disponibles",
      badge: "Recherche intelligente",
    },
    step3: {
      title: "Proposez un échange et négociez",
      description:
        "Contactez le propriétaire qui vous intéresse et proposez un échange. Négociez les dates et la durée dans un esprit convivial. 10 nuits contre 5 ? Tout est possible !",
      highlight1: "Messagerie intégrée et sécurisée",
      highlight2: "Négociation flexible des durées",
      highlight3: "Profils vérifiés et avis consultables",
      badge: "Négociation facile",
    },
    step4: {
      title: "Confirmez les dates et synchronisez vos calendriers",
      description:
        "Une fois l'accord trouvé, confirmez les dates d'échange. Vos calendriers Airbnb et DONKEY TRAVEL se synchronisent automatiquement pour éviter tout conflit de réservation.",
      highlight1: "Synchronisation automatique avec Airbnb",
      highlight2: "Rappels et notifications avant le séjour",
      highlight3: "Modification flexible jusqu'à 48h avant",
      badge: "Calendrier synchronisé",
    },
    step5: {
      title: "Contrat amiable PDF envoyé aux deux hôtes",
      description:
        "DONKEY TRAVEL édite un contrat amiable en PDF et l'envoie aux deux hôtes. Une fois le premier échange terminé, vous disposez de 24 mois pour effectuer l'échange retour.",
      highlight1: "Contrat amiable PDF envoyé automatiquement aux 2 hôtes",
      highlight2: "Document récapitulatif des dates et conditions validées",
      highlight3:
        "24 mois pour réaliser l'échange retour après le premier séjour",
      badge: "Contrat PDF",
    },
    step6: {
      title: "Voyagez et profitez de votre séjour gratuit !",
      description:
        "C'est le grand jour ! Installez-vous dans votre logement d'échange et profitez de vacances authentiques. Après votre séjour, laissez un avis pour aider la communauté.",
      highlight1: "Accueil personnalisé par le propriétaire",
      highlight2: "Guide local avec recommandations",
      highlight3: "Système d'avis après chaque échange",
      badge: "Bon voyage !",
    },
  },
  advantages: {
    badge: "Nos avantages",
    title: "Pourquoi choisir DONKEY TRAVEL ?",
    subtitle:
      "Une plateforme pensée pour les propriétaires Airbnb qui veulent voyager autrement",
    items: {
      security: {
        title: "Sécurité maximale",
        description:
          "Tous les membres sont des propriétaires Airbnb vérifiés. Identité contrôlée, avis consultables pour chaque échange.",
      },
      savings: {
        title: "Économies considérables",
        description:
          "Voyagez gratuitement en échangeant vos nuits. Économisez en moyenne 2 500€ par an sur vos frais d'hébergement.",
      },
      community: {
        title: "Communauté de confiance",
        description:
          "Rejoignez notre communauté de voyageurs. Partagez vos expériences, échangez des conseils et créez des liens durables.",
      },
      support: {
        title: "Assistance 7j/7",
        description:
          "Notre équipe est disponible à tout moment pour vous accompagner. Chat en direct, email et téléphone pour une assistance complète.",
      },
      quality: {
        title: "Logements de qualité",
        description:
          "Chaque logement est vérifié et noté par la communauté. Des standards élevés pour garantir des séjours exceptionnels.",
      },
      global: {
        title: "Réseau européen",
        description:
          "Accédez à des hôtes vérifiés dans les pays européens disponibles du club et organisez vos échanges en confiance.",
      },
    },
  },
  testimonials: {
    badge: "Témoignages",
    title: "Ils ont testé et approuvé",
    subtitle: "Découvrez les expériences de nos membres à travers le monde",
    banner: {
      title: "Vous aussi, partez plus souvent !",
      subtitle: "Rejoignez la communauté d'hôtes qui voyagent autrement.",
    },
    items: {
      sophie: {
        name: "Sophie",
        location: "Paris, France",
        badge: "2 échanges",
        text: "Grâce à DONKEY TRAVEL, j'ai visité Barcelone, Rome et Amsterdam sans payer d'hébergement. La communauté est réactive et les discussions d'échange sont simples.",
      },
      marc: {
        name: "Marc",
        location: "Marseille, France",
        badge: "1 échange",
        text: "Le processus est tellement simple. En 3 jours, j'avais trouvé un échange parfait pour mes vacances d'été. La synchronisation avec Airbnb est un vrai plus.",
      },
      leaTom: {
        name: "Léa & Tom",
        location: "Lyon, France",
        badge: "Nouveaux membres",
        text: "Ce qui m'a le plus séduite, c'est la communauté. Les propriétaires sont bienveillants et les échanges se font dans une ambiance de confiance totale.",
      },
      dupont: {
        name: "Famille Dupont",
        location: "Bordeaux, France",
        badge: "3 échanges",
        text: "Idéal pour voyager en famille pendant les vacances scolaires !",
      },
      alex: {
        name: "Alex",
        location: "Berlin, Allemagne",
        badge: "5 échanges",
        text: "Un réseau incroyable pour le télétravail. J'échange mon loft berlinois contre des appartements au soleil.",
      },
      marie: {
        name: "Marie",
        location: "Toulouse, France",
        badge: "4 échanges",
        text: "Plus aucune contrainte financière ! Je pars en week-end tous les mois.",
      },
    },
  },
  faq: {
    title: "Questions fréquentes",
    subtitle: "Tout ce que vous devez savoir avant de commencer",
    items: {
      q1: {
        question: "L'inscription est-elle payante ?",
        answer:
          "Oui. L'accès à DONKEY TRAVEL se fait via un abonnement annuel. Offre lancement 2026 : 25EUR/an au lieu de 50EUR/an.",
      },
      q2: {
        question: "Dois-je être propriétaire Airbnb pour m'inscrire ?",
        answer:
          "Oui, DONKEY TRAVEL est réservé aux propriétaires ayant un logement listé sur Airbnb. Cela garantit la qualité et la fiabilité de chaque membre de la communauté.",
      },
      q3: {
        question: "Comment sont protégés les échanges ?",
        answer:
          "Tous les membres sont vérifiés (identité, logement, avis Airbnb) et notre équipe support est disponible 7j/7.",
      },
      q4: {
        question: "Puis-je échanger avec quelqu'un dans un autre pays ?",
        answer:
          "Oui. Vous pouvez échanger avec d'autres hôtes vérifiés dans les pays européens disponibles selon votre abonnement.",
      },
      q5: {
        question: "Que se passe-t-il si l'échange est annulé ?",
        answer:
          "Notre politique d'annulation protège les deux parties. En cas d'annulation, nous vous aidons à trouver une alternative.",
      },
      q6: {
        question: "Combien de temps dure un échange en moyenne ?",
        answer:
          "La durée est totalement flexible et se négocie entre les deux propriétaires. En moyenne, les échanges durent entre 5 et 14 nuits, mais certains font des échanges d'un week-end ou d'un mois entier.",
      },
    },
  },
  cta: {
    title: "Prêt à voyager gratuitement ?",
    subtitle: "Rejoignez notre communauté de voyageurs.",
    explore: "Explorer les destinations",
    members: "Membres actifs",
    countries: "Pays disponibles",
    satisfaction: "De satisfaction",
  },
};
